import React, { useState } from "react";
import RegisterForm from "./RegisterForm";
import LinkButton from "components/LinkButton";
import AuthLayout from "layouts/AuthLayout";
import { twMerge } from "tailwind-merge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

export default function Register() {
  const [registerSuccessful, setRegisterSuccessful] = useState(false);

  if (registerSuccessful) {
    return (
      <AuthLayout>
        <div className="rounded-tr-4xl basis-full z-10 text-center">
          <div
            className={twMerge(
              "h-[60px] w-[60px] mx-auto mt-3 mb-6 rounded-full transition-all flex justify-center items-center bg-sky-500 text-slate-100"
            )}
          >
            <FontAwesomeIcon className="text-3xl" icon={faEnvelope} />
          </div>
          <h1 className="text-2xl font-semibold ">Təsdiq mesajı göndərildi</h1>
          <p className="mt-4">
            Zəhmət olmasa, hesabınıza daxil olmaq üçün e-poçt ünvanınızı təsdiqləyin
          </p>
          <LinkButton to="/login" className="mt-8 w-full">
            Giriş səhifəsinə keç
          </LinkButton>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <h1 className="text-2xl font-semibold mb-4">Qeydiyyat</h1>
      <RegisterForm
        onRegister={({ data }) => {
          setRegisterSuccessful(true);
        }}
      />
    </AuthLayout>
  );
}
